var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"dark my-3","size":"sm"},on:{"click":function($event){return _vm.deleteQuestion(_vm.questionId, _vm.bookId)}}},[_vm._v("削除")])}
var staticRenderFns = []

export { render, staticRenderFns }